import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaUser, FaPhone } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const buttonRef = useRef(null);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        buttonRef.current &&
        !navRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };


    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };


    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header>
      <div className="header-container">
        <Link to="/" className="logo-section">
          <img src="/images/logo.png" alt="Nalumer Logo" className="logo-img" />
          <span className="logo-text">Nalumer</span>
        </Link>
                <button 
          ref={buttonRef}
          className="hamburger-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

<nav ref={navRef} className={isMenuOpen ? 'active' : ''}>
          <ul>
            <li>
              <Link to="/" onClick={closeMenu}>
                <FaHome style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                Αρχική
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={closeMenu}>
                <FaUser style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                Σχετικά
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeMenu}>
                <FaPhone style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                Επικοινωνία
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;